import { License, ListAccess, Period } from '®shared/tenant';

import { EditableList } from './editable-list';
import { ReadingListDetails } from './reading-list-details';

export class ListDetailsFormModel {
  title = '';
  description: string | null = null;
  internalNote: string | null = null;
  license: License | null = null;
  timePeriod: Period | null = null;
  listAccess: ListAccess | null = null;

  constructor(editableList?: EditableList) {
    if (editableList) {
      this.title = editableList.title;
      if (editableList.description) {
        this.description = editableList.description;
      }
      if (editableList.internalNote) {
        this.internalNote = editableList.internalNote;
      }
      if (editableList.listAccess) {
        this.listAccess = editableList.listAccess;
      }
      if (editableList.license) {
        this.license = editableList.license;
      }
      if (editableList.period) {
        this.timePeriod = editableList.period;
      }
    }
  }

  toReadingListDetails(): ReadingListDetails {
    return Object.assign(new ReadingListDetails(), {
      title: this.title,
      description: this.description === '' ? null : this.description,
      internal_note: this.internalNote === '' ? null : this.internalNote,
      list_access: this.listAccess,
      license: this.license,
      period: this.timePeriod,
    });
  }
}
